import {
  eventDispatcher,
  TOPICS,
  MCAPPS,
  INavToParams
} from "@origin-digital/event-dispatcher";
import { logger } from "@origin-digital/reporting-client";
import { LinkTextProps } from "@origin-digital/style-guide";

const isNavToLink = (href: string): boolean =>
  href.indexOf(TOPICS.NAV_TO) === 0;

const getNavToProps = (linkProps: LinkTextProps): Partial<LinkTextProps> => {
  // @ts-ignore
  const [topic, event] = linkProps.href.split(":");
  const [to, query] = event.split("?");

  if (MCAPPS[to] === undefined) {
    logger.warn(
      `[@od/style-guide] <Markdown />: ${to} is not a valid entry in MCAPPS`
    );
  }

  const parameters: Partial<INavToParams> = {};
  if (query) {
    query.split("&").map(item => {
      const [key, value] = item.split("=");
      parameters[key] = value;
    });
  }

  return {
    href: "#",
    onClick: () =>
      eventDispatcher.dispatch({
        topic: TOPICS.NAV_TO,
        payload: {
          to: MCAPPS[to],
          parameters
        } as any
      })
  };
};

type AddMeshLinkProps = LinkTextProps & { key: number };
export const addMeshLinks = (linkProps: AddMeshLinkProps): AddMeshLinkProps => {
  if (linkProps.href && isNavToLink(linkProps.href)) {
    const newData = getNavToProps(linkProps);
    return {
      ...linkProps,
      ...newData
    };
  }

  return linkProps;
};
